// Post-combat reward screen.
// All combat: full heal.
// Brawl: whole team gains XP.
// Boss nodes advance to the next act (or end the run after act 3).

import type { Scene } from "../engine/scene/SceneManager";
import type { Game } from "../game/Game";
import type { MapNode } from "../map/CampaignMap";
import { MapScene } from "./MapScene";
import { MainMenuScene } from "./MainMenuScene";
import { buildXpReveal } from "../ui/XpReveal";

export const MINION_XP = 1400;

const JUNGLE_CAMP_XP: Record<string, number> = {
  raptor: 700,
};
const DEFAULT_JUNGLE_XP = 700;
export function jungleCampXp(campType: string | undefined): number {
  return JUNGLE_CAMP_XP[campType ?? ""] ?? DEFAULT_JUNGLE_XP;
}

export class RewardScene implements Scene {
  private root: HTMLDivElement;
  constructor(
    private game: Game,
    private node: MapNode,
  ) {
    this.root = document.createElement("div");
    this.root.className = "reward-screen";
  }

  enter(): void {
    const state = this.game.runState;
    if (!state) {
      this.game.sceneManager.transition(new MainMenuScene(this.game));
      return;
    }

    const isJungle = this.node.type === "jungle";
    const isMinion = this.node.type === "minion";

    const titleEl = document.createElement("div");
    titleEl.className = "reward-title";
    titleEl.textContent = "VICTORY";
    this.root.appendChild(titleEl);

    if (isJungle) {
      const xp = jungleCampXp(this.node.campType);
      const preRoster = state.roster.map((r) => ({ ...r }));
      state.grantXpToAll(xp);

      const xpEl = document.createElement("div");
      xpEl.style.cssText = "color:var(--accent-hot);font-size:13px";
      xpEl.textContent = `Whole team +${xp} XP`;
      this.root.appendChild(xpEl);
      this.root.appendChild(buildXpReveal(preRoster, state.roster));
    }

    if (isMinion) {
      const fighterId = state.combatFighterIds?.[0];
      const preRoster = state.roster.map((r) => ({ ...r }));
      if (fighterId) {
        state.grantXpTo(fighterId, MINION_XP);
      } else {
        state.grantXpToAll(MINION_XP);
      }
      const xpEl = document.createElement("div");
      xpEl.style.cssText = "color:var(--accent-hot);font-size:13px";
      xpEl.textContent = `Fighter +${MINION_XP} XP`;
      this.root.appendChild(xpEl);
      this.root.appendChild(buildXpReveal(preRoster, state.roster));
    }

    const btn = document.createElement("button");
    btn.className = "btn";
    btn.style.marginTop = "8px";
    btn.textContent = "CONTINUE";
    btn.addEventListener("click", () => this.proceed());
    this.root.appendChild(btn);

    this.game.sceneRoot.appendChild(this.root);
  }

  private proceed(): void {
    const state = this.game.runState;
    if (!state) {
      this.game.sceneManager.transition(new MainMenuScene(this.game));
      return;
    }

    state.combatFighterIds = null;
    this.game.sceneManager.transition(new MapScene(this.game));
  }

  exit(): void {
    this.root.remove();
  }

  update(_dt: number): void {}
  render(_ctx: CanvasRenderingContext2D): void {}
}
